import React, { lazy, Suspense, useEffect, useState } from 'react'

const TOC = lazy(() => import('./TOC'))

export interface TOCWrapperProps {
  content: string
}

export default function TOCWrapper({ content }: TOCWrapperProps) {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return isMounted ? (
    <Suspense fallback={<div />}>
      <TOC content={content} />
    </Suspense>
  ) : null
}
